<log-cinematic-sub-section-wrapper header="{{ l10nKeys.grpcLabel | vtranslate }}">
    <div class="log-cinematic-section-protocol">
        <ng-container *ngrxLet="grpcInfo$ as grpcInfo">
            <!-- Left column -->
            <div logCinematicSectionColumn>
                <div
                    logFieldTitle
                    [withMarginTop]="false"
                >
                    {{ l10nKeys.grpcServiceNameLabel | vtranslate }}
                </div>
                <span
                    *ngIf="grpcInfo.grpc_service_name as grpcServiceName; else na"
                    logFilter
                    property="grpc_service_name"
                    [value]="grpcServiceName"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ grpcServiceName }}
                </span>
            </div>

            <!-- Middle column -->
            <div logCinematicSectionColumn>
                <div
                    logFieldTitle
                    [withMarginTop]="false"
                >
                    {{ l10nKeys.grpcMethodNameLabel | vtranslate }}
                </div>
                <span
                    logFilter
                    *ngIf="grpcInfo.grpc_method_name as methodName; else na"
                    property="grpc_method_name"
                    [value]="methodName"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"

                >
                    {{ methodName }}
                </span>
            </div>

            <!-- Right column -->
            <div logCinematicSectionColumn>
                <div
                    logFieldTitle
                    [withMarginTop]="false"
                >
                    {{ l10nKeys.grpcStatusReasonPhraseLabel | vtranslate }}
                </div>
                <span
                    logFilter
                    *ngIf="grpcInfo.grpc_status_reason_phrase as reasonPhrase; else na"
                    property="grpc_status_reason_phrase"
                    [value]="reasonPhrase"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ reasonPhrase }}
                </span>
            </div>
        </ng-container>
    </div>
</log-cinematic-sub-section-wrapper>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>
